import { type JanusCtx, type Row, ecId, ecLean, handBack, itemField, upper } from './context.js';
import { phpEmpty } from '../turns/regeneration-entry-gate.js';

/** make_contesting_roll(): PHP's null fall-through means no roll. Read only held page facts. */
export function makeContestingRoll(ctx: JanusCtx, caster: Row, target: Row): boolean {
  // Either native type location can identify a lair, including a self-targeted one.
  if (itemField(target, 'item_type') === 'lair' || ecLean(target, 'item_type') === 'lair') return false;
  const casterId = ecId(caster), targetId = ecId(target);
  if (!casterId || !targetId) return false;
  if (casterId === targetId) return true;
  const sameType = ecLean(caster, 'item_type') === ecLean(target, 'item_type');
  const controller = ecLean(target, 'controller_encounter_creature_id');
  const controlled = !phpEmpty(controller);
  if (sameType) return !controlled || upper(controller) === casterId;
  if (controlled && upper(controller) === casterId) return false;
  if (['body', 'mind', 'spirit'].every(key => ctx.read.value(target, key) != null)) return true;
  // The page certifies this only after fetching the full target compile. A lean roster
  // cannot prove that an absent essence is absent from the creature itself.
  if (!ctx.read.reactionInventoryComplete(target)) handBack('template_contesting_roll:essence-not-held');
  return false;
}
